module.exports = "<span class=\"info\">\n  Quantidade de registros por página: {{pageSize}}\n</span>"